import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import { useCallback, useContext, useState } from 'react';
import MaritimeDirectoryPortColumnContext from './MaritimeDirectoryPortEditorContext';
import { maritimeDirectoryPortModel } from 'model';
import { DeleteModal } from 'components/DeleteModal';
import capitalize from '../../../../../shared/stringUtils/capitalize';
import { TXT_DELETE_TEXT } from '../../../../../shared/translations';
import { DELETE_MARITIME_DIRECTORY_PORT } from 'api/graphql/maritimeDirectoryPort/maritimeDirectoryPort.mutations';

interface MaritimeDirectoryPortDeleteProps {
  maritimeDirectoryPort: Partial<maritimeDirectoryPortModel>;
}

const MaritimeDirectoryPortDelete = (props: MaritimeDirectoryPortDeleteProps) => {
  const { t } = useTranslation();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const { refresh } = useContext(MaritimeDirectoryPortColumnContext);

  const toggleConfirmation = useCallback(() => {
    setShowConfirmation((prev) => !prev);
  }, []);

  const afterSaving = useCallback(() => {
    toggleConfirmation();
    refresh();
  }, [refresh, toggleConfirmation]);

  return (
    <>
      {showConfirmation && props.maritimeDirectoryPort.id ? (
        <DeleteModal
          txtConfirmation={
            capitalize(
              t(TXT_DELETE_TEXT, {
                name: props.maritimeDirectoryPort.port?.name || ''
              })
            )!
          }
          afterSaving={afterSaving}
          input={{
            id: props.maritimeDirectoryPort.id
          }}
          mutation={DELETE_MARITIME_DIRECTORY_PORT}
          onCancel={toggleConfirmation}
        />
      ) : null}
      <IconButton color="error" onClick={toggleConfirmation}>
        <DeleteIcon />
      </IconButton>
    </>
  );
};

export default MaritimeDirectoryPortDelete;
